import {useActions, useGetters, useMutators, useState} from './_default';
export default {
    namespaced: true,
    state: {
        ...useState(),
        expanded: true,
    },
    getters: {
        ...useGetters(),
        expanded: state => state.expanded,
    },
    mutations: {
        ...useMutators(),
        expanded(state, status) {
            state.expanded = status;
        }
    },
    actions: {
        ...useActions(),
    },
}
